import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit, TemplateRef
} from '@angular/core';
import {
  ApplicationService
} from '../../shared/services/application.service';
import {
  ApplicationDetail,
  DocumentDetail,
  InspectionInfoDetail,
  ChangeType,
  AppHistoryLog
} from '../../models/ApplicationDetail';
import {
  Router,
  ActivatedRoute
} from '@angular/router';
import {
  UserDto
} from '../../models/User';
import {
  AccountService
} from '../../services/account.service';
import * as Constants from '../../models/Constants';
import {
  PreviewModalService
} from '../../shared/services/preview-modal.service';
import {
  SubDataVariables
} from '../../../environments/app.variables';
import {
  saveAs
} from 'file-saver';
import {
  FileUploader
} from 'ng2-file-upload';
import {
  CheckListValueModel,
  Document,
  ApplicationInfo,
  PendingPaymentInfo,
  PaymentRequest
} from '../../models/ApplicationModel';
import {
  FileLikeObject
} from 'ng2-file-upload';
import {
  DocumentRef
} from '../../models/DocumentRef';
import {
  AlertService
} from '../../shared/services/alert.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import {
  clearEthSwitchAttemptMarker,
  hasEthSwitchIncompleteAttempt,
  markEthSwitchAttemptIncomplete,
  openPaymentCheckoutUrl
} from '../../shared/utils/ethswitch-payment.util';

const URL = environment.baseUrl + '/Attachment';
import { FoodManufDoc, FIRItem, ProfessionalType } from '../../models/CommonModels';
import { ErrorHandlerService } from '../../services/error-handler.service';
import {
  formatDisallowedTypeMessage,
  PDF_FILE_TOO_LARGE_MESSAGE
} from '../../shared/helpers/pdf-upload-validator';
import {ProfessionalConfigFilter} from '../../models/ProfessionalType';
import { SettingsService } from '../../shared/services/settings.service';
import {ErisLoginService} from '../../services/sso/eris-login.service';
import { MapsAPILoader } from '@agm/core';
import { error } from 'jquery';
import { take } from 'rxjs/operators';
import {
  extractTelebirrNotifyFields,
  isTelebirrCallbackSuccess
} from '../../shared/helpers/telebirr-return.util';

@Component({
  selector: 'app-application-detail',
  templateUrl: './application-detail.component.html',
  styleUrls: ['./application-detail.component.css']
})

export class ApplicationDetailComponent implements OnInit, AfterViewInit {
  application: ApplicationDetail = null;
  applicationInfo: ApplicationInfo = null;
  applicationId: string;
  showManufacturing = false;
  showFoodManufacturing = false;
  currentUser: UserDto;
  currentUserRoleCodes: String[];
  errorMessage: String;
  modalTitle: string;
  modalButtonLabel: string;
  modalApplicationStatus: string;
  constants: any = Constants;
  modalRef: BsModalRef;

  // Buttons
  showPrescreeningActions = false;
  showChecklistScreeningActions = false;
  showSelfInspectionActions = false;
  showPaymentMadeActions = false;
  showRequestFIRAction = false;
  showInspectionResultTab = false;
  showEditActionButtons = false;
  showApproveRejectActions = false;
  showGenerateCertificate = false;
  showPreviewCertificate = false;
  showPreviewNotification = false;
  showInspectionPassedActions = false;
  showReturnToInspectorActions = false;
  showSubmitForFIRAction = false;
  showSubmitLegacyDataForFIRAction = false;
  showReturnToCSOAction = false;
  showAssignInspectorForSiteInspectionAction = false;
  showInspectionFailedActions = false;
  showInspectionRejectedActions = false;
  showRejectActions = false;
  showApproveActions = false;
  showCloseActions = false;
  showRtrnToInspTeamLeaderActions = false;
  showSubmitForApproval = false;
  showInspectorTMLPrescreenedRenewalActions = false;
  showDeleteActionButton = false;
  showUndoDeleteActionButton = false;
  showUndoLicenseSuspensionActionButton = false;
  screenerResponseIncomplete = true;
  showChangeTab = false;
  showFIRTab = false;
  showReplacementTab = false;
  showReturnCOCTab = false;
  showChecklistTab = false;
  showWarehousesTab = false;
  showPaymentTab = false;
  showPaymentMethod = false;
  showCashPayment = true;
  selectedPaymentMethod = "CASH";
  telebirrPayingBillRef: string | null = null;
  ethSwitchPayingBillRef: string | null = null;
  private ethSwitchCheckoutOpenedAt = 0;
  private ethSwitchReconcileBillRef: string | null = null;
  private ethSwitchCheckoutWindowHidden = false;
  private ethSwitchReturnIncompletePending = false;
  /** Avoid repeated auto-reconcile loops on the same paymentInfo while this page is open. */
  private ethSwitchAutoReconcileAttemptedIds = new Set<number>();
  private ethSwitchReconcileInFlight = false;
  /** Per-click chooser: '' = backend default, 'C2B' = H5 consumer instant pay, 'B2B' = H5 business. */
  selectedTelebirrMode: string = environment.telebirrCheckoutMode || '';
  showInspectionInfoRequestTab = false;
  showReturnToCSOTeamLeaderAction = false;
  showQuarantineActionButton = false;
  showUndoQuarantineActionButton = false;
  showLicenseGeneratedAction = false;
  showVoidCertificateAction = false;
  showDeleteQRCodeButton = false;
  showCancellationLetter = false;
  showSuspensionLetter = false;
  inspectionResults: InspectionInfoDetail[];
  historyLog: Array<AppHistoryLog> = [];
  spanDescription: string;

  diff: Object = {};
  count: number;
  documentRefs: Array<DocumentRef> = [];
  feeDocumentRefs: Array<DocumentRef> = [];
  attachedDocs: Array<any> = [];
  _changeTypes: Array<ChangeType> = [];
  _FIRItems: Array<FIRItem> = [];

  currentAttachmentID: number;
  prodTypeID: number;
  facilityTypeID: number;
  totalChangeFee: number;

  uploader: FileUploader;
  uploadErrorMessage: string;
  documents: Array<Document> = [];
  feeDocuments: Array<DocumentDetail> = [];
  activeTab: string;
  currentReciptNumber: string;
  currentPaymentDoc: DocumentDetail;
  modalMode: boolean;
  compareMode = false;
  checklistDiff: number;
  private containsPreview:boolean = false;
  private containsCertificate:boolean = false;
  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  private inputs: string[] = [
    'allowedFileType',
    'headers',
    'maxFileSize',
    'url'
  ];
  applicationID: number;
  private showLicenseNumber: boolean = false;
  editedFields = [];
  changedFields: any;
  changedTabs: string[] = [];
  changeSummary: string;
  responseLabel = '';
  public detailReady = false;
  public configuredProfessionalTypes: Array<ProfessionalType> = [];
  public pAndpi: string[][] = new Array();
  public tempData: string[] = [];
  public showFileColumnsInspectionResult = false; // used to hide file name and file preview columns if file upload is not used for all inspection results
  public showOdkColumnsInspectionResult = false; // used to hide identifier and form preview columns if odk is not used for all inspection result
  public showEnketoForm = false;
  public currentInspectionResult = null;
  public editDocuments: DocumentDetail[] = [];

  // used to retrieve facility gps location from the applicant
  public facilityLocLatitiude: number;
  public facilityLocLongitude: number;
  public preInspectionDocRefs: DocumentRef[] = [];
  public ETH_LAT_LOWER = 3.42206;
  public ETH_LAT_HIGHER = 14.95943;
  public ETH_LNG_LOWER = 32.95418;
  public ETH_LNG_HIGHER = 47.78942;
  public pendingPaymentInformation: PendingPaymentInfo;
  public paymentAmount: number;
  public request: PaymentRequest;

  constructor(private alertService: AlertService, private router: Router, private applicationService: ApplicationService,
    private previewService: PreviewModalService, private route: ActivatedRoute, private accountService: AccountService,
    private modalService: BsModalService, private spinner: NgxSpinnerService, private errorHandlerService: ErrorHandlerService,
    private settingsService: SettingsService, private erisLoginService: ErisLoginService, private mapsAPILoader: MapsAPILoader,
    private changeDetectorRef: ChangeDetectorRef) {

    this.currentUser = this.accountService.getUserData();
    this.currentUserRoleCodes = this.accountService.getUserRoleCodes();
  }

  activateTab(tab) {
    this.activeTab = tab;
    this.syncBootstrapTabState();
  }

  onTabNavClick(event: Event): void {
    const anchor = (event.target as HTMLElement).closest('a[href^="#"]');
    if (!anchor) {
      return;
    }
    const href = anchor.getAttribute('href');
    if (!href || !href.startsWith('#')) {
      return;
    }
    this.activeTab = href.substring(1);
    setTimeout(() => this.syncBootstrapTabState(), 0);
  }

  private syncBootstrapTabState(): void {
    if (!this.activeTab) {
      return;
    }
    setTimeout(() => {
      const tabId = this.activeTab;
      $('.tab-content > .tab-pane').removeClass('active').hide();
      const $pane = $('#' + tabId);
      if ($pane.length) {
        $pane.addClass('active').show();
      }
      $('.nav-tabs > li').removeClass('active');
      $('.nav-tabs a[href="#' + tabId + '"]').parent('li').addClass('active');
    }, 0);
  }

  showActionButton() {
    return this.showPrescreeningActions || this.showPaymentMadeActions || this.showInspectionPassedActions ||
      this.showInspectionFailedActions || this.showInspectionRejectedActions || this.showApproveActions || this.showRejectActions ||
      this.showRtrnToInspTeamLeaderActions || this.showInspectorTMLPrescreenedRenewalActions || this.showChecklistScreeningActions ||
      this.showLicenseGeneratedAction || this.showReturnToInspectorActions || this.showReturnToCSOAction ||
      (this.showSubmitForFIRAction && this.showReturnToInspectorActions) || this.showSubmitForApproval || this.showSubmitLegacyDataForFIRAction;
  }

  showFeeAttachmentTab() {
    const isCorrectStatusCode = [Constants.PAYMENT_MADE_CODE, Constants.PAYMENT_VERIFICATION_FAILED_CODE,
    Constants.RETURN_TO_APPLICANT_CODE, Constants.VERIFIED_CODE].indexOf(this.application.applicationStatusCode) !== -1;
    if (this.accountService.isUserApplicant() && isCorrectStatusCode) {
      this.applicationService.getRepeatedInspectionFee(this.applicationID).subscribe(resp => {
        this.showPaymentTab = true;
        this.showPaymentMethod = this.application.applicationStatusCode ===  Constants.RETURN_TO_APPLICANT_CODE;
        this.activeTab = 'feeAttachment';
        this.paymentAmount = resp.data;
        this.activateTab(this.activeTab);
      });

    } else {
      this.showPaymentTab = false;
      this.activeTab = 'applicantInfo';
      this.activateTab(this.activeTab);
    }
    console.log('show pay,ent: ', this.showPaymentTab);

  }

  isPaymentAttached(): any {
    return this.attachedDocs.filter(doc => {
      return doc.referenceID === Constants.PAYMENT_REFERENCE_ID;
    }).length > 0;
  }

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    switch (filter.name) {
      case 'fileSize':
        this.uploadErrorMessage = PDF_FILE_TOO_LARGE_MESSAGE;
        break;
      case 'fileType':
        this.uploadErrorMessage = formatDisallowedTypeMessage(item.type || 'unknown');
        break;
      default:
        this.uploadErrorMessage = `Unknown error (filter is ${filter.name})`;
    }
  }

  ngAfterViewInit() {
    this.showPaymentTab = true;

    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const notifyFields = extractTelebirrNotifyFields(params);
      if (notifyFields) {
        this.reconcileTelebirrReturn(notifyFields);
      }
    });

    this.route.params.subscribe(params => {
      this.applicationID = params['id'];
      this.handleEthSwitchReturnQueryParams();
      this.viewHistoryLog(this.applicationID);
      this.getApplication();
    });
  }

  private handleEthSwitchReturnQueryParams(): void {
    const incomplete = this.route.snapshot.queryParams['ethSwitchPaymentIncomplete'];
    if (incomplete !== '1') {
      return;
    }
    this.ethSwitchReturnIncompletePending = true;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { ethSwitchPaymentIncomplete: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  private reconcileTelebirrReturn(notifyFields: Record<string, string>) {
    const billRef = notifyFields['merch_order_id'];
    this.applicationService.telebirrPaymentReturn(notifyFields).subscribe(
      result => {
        if (isTelebirrCallbackSuccess(result)) {
          this.alertService.success('Telebirr payment confirmed successfully.');
          this.getApplication();
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {},
            replaceUrl: true
          });
          return;
        }

        if (result && result.code === '0' && result.msg === 'ignored') {
          this.applicationService.getApplicationIdByTelebirrBill(billRef).subscribe(lookup => {
            if (lookup?.applicationId || lookup?.ApplicationId) {
              this.alertService.success('Telebirr payment was already confirmed.');
              this.getApplication();
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {},
                replaceUrl: true
              });
            }
          });
          return;
        }

        this.alertService.warn(
          'Telebirr reported payment success but the application could not be updated automatically. ' +
          'Please refresh this page or contact support with bill reference ' + billRef + '.'
        );
      },
      () => {
        this.alertService.error(
          'Could not confirm Telebirr payment with the server. Please refresh this page or try again.'
        );
      }
    );
  }

  isFieldEdited(controlName,controlGroup) {
    if([Constants.FI_SUBMITTED, Constants.FI_SUBMITTED_AFTER_INSPECTION].includes(this.application.applicationStatusCode)){
      let editField:FIRItem[] = JSON.parse(this.application.editedFields);
        if(!editField){
          return '';
        }

        let groupIndex = editField.findIndex(item => item.name === controlGroup);

        if(groupIndex === -1){
          return '';
        }
        else if(controlGroup === 'Documents'){
          return {'highlight-text': editField[groupIndex].subItems.findIndex(item => item.name === this.documentRefs[controlName].name) !== -1};
        }
        else if(controlGroup === 'Facility Professionals'){
          return {'highlight-text': editField[groupIndex].subItems.findIndex(item => item.name === controlName) !== -1};
        }
        else if(!Constants.FIR_ITEMS_DETAIL_MAP[controlName]){
          return '';
        }
        else{
          return {'highlight-text': editField[groupIndex].subItems.findIndex(item => item.name === Constants.FIR_ITEMS_DETAIL_MAP[controlName]) !== -1};
        }
    }
    else{
      return { 'highlight-text': this.editedFields.indexOf(controlName) > -1 };
    }
  }
  isTabEdited(controlNames) {

    return { 'highlight-text': this.changedTabs.some(c => controlNames.indexOf(c) >= 0)}
  }

  private getApplication() {
    const preservePayingRef = this.ethSwitchPayingBillRef;
    this.applicationService.getApplication(this.applicationID).subscribe(
      data => {       
        if (data) {
          this.setExperienceRange(data);  
        }

        this.application = new ApplicationDetail(data, null);        
        this.application = this.checkForOldAndNewValue(this.application);
        
        const specificProducts = this.application.specificProductObjects || [];
        const specificProductItems = this.application.specificProductItemObjects || [];
        for(let i=0; i< specificProducts.length; i++){
          if (!specificProducts[i]) {
            continue;
          }
          this.tempData = [];
          this.tempData.push(specificProducts[i].name);
          for(let l=0; l< specificProductItems.length; l++){
              if (specificProductItems[l] && specificProductItems[l].specificProductID === specificProducts[i].id){
                let spItem = specificProductItems[l].name;
                this.tempData.push(spItem);
              }
          }
          this.pAndpi.push(this.tempData);

        }
        console.log(this.application.facility);
        if (this.application.facility && this.application.facility.facilityType === Constants.MANUFACTURER) {
          this.showManufacturing = true;
          if (this.application.productType === Constants.PRODUCT_TYPE_FOOD) {
            this.showFoodManufacturing = true;
          }
        }

        this.fetchConfiguredProfessionalTypes();
        this.applicationInfo = (<any>data).applicationInfo;
        const categoryCode = this.application.applicationCategory && this.application.applicationCategory.applicationCategoryCode;
        this.showWarehousesTab = categoryCode === Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE ||
          categoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE ||
          (this.application.warehouses != null && this.application.warehouses.length > 0);

        if (this.application.applicationCategory && this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL) {
          this.responseLabel = 'Inspector Response';
        } else {
          this.responseLabel = 'Screener Response';
        }

        if([Constants.FIR_SUBMITTED, Constants.FI_SUBMITTED, Constants.LEGACY_DATA_EDITED_CODE, Constants.FIR_SUBMITTED_AFTER_INSPECTION, Constants.FI_SUBMITTED_AFTER_INSPECTION].includes(this.application.applicationStatusCode)){
            let firItems = null;
          try {
            firItems = this.application.editedFields ? JSON.parse(this.application.editedFields) : null;
          } catch (e) {
            firItems = null;
          }
          if(firItems && Array.isArray(firItems)){
            this.showFIRTab = true;
            this._FIRItems = firItems.filter(function(value, index, arr){
              return value.name;
            });
          }
        }
        if(categoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
          categoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE){
            this.showChangeTab = true;
            this.totalChangeFee = 0;
            this.changeSummary = this.application.changeSummary;
            (this.application.newApplicationChangeTypes || []).forEach(newApplicationChangeType =>{
              if (!newApplicationChangeType || !newApplicationChangeType.changeType) {
                return;
              }
              this.changedTabs.push(newApplicationChangeType.dataType);
              this._changeTypes.push(newApplicationChangeType.changeType)
              if (newApplicationChangeType.oldValueObj && newApplicationChangeType.newValueObj) {
                this.changedFields =  this.compare(newApplicationChangeType.oldValueObj, newApplicationChangeType.newValueObj, newApplicationChangeType.dataType)
              }
              console.log('changed fields' , this.changedFields)
            });
          let tempCOC = this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ? false : true;
          this._changeTypes.forEach(changeType =>{
            if (!changeType) {
              return;
            }

            this.applicationService.calculateFeeForFacilityChange(this.application.facilityID,changeType.changeTypeRefID, tempCOC).subscribe(
              data =>{
                  changeType.changeFee = data.fee;
                  this.totalChangeFee += changeType.changeFee;
              }
            )


            this.editedFields = Object.keys(this.changedFields || {});
            console.log('edited fields ', this.editedFields);
          })



        }
        else if(categoryCode === Constants.APPLICATION_TYPE_CODE_REPLACEMENT){
          this.showReplacementTab = true;
        }
        else if([Constants.APPLICATION_TYPE_CODE_RETURN_COC, Constants.APPLICATION_TYPE_CODE_TEMP_RETURN_COC ].indexOf(
          categoryCode) !== -1){
          this.showReturnCOCTab = true;
        }
        // this.editedFields = JSON.parse(this.application.editedFields) ? JSON.parse(this.application.editedFields).fields : [];

        if (this.application.checkListItems && this.application.checkListItems.length) {
          this.showChecklistTab = true;
          this.application.checkListItems.forEach(function (checklist) {
            if (checklist.screenerResponseValue === null) {
              checklist.screenerResponseValue = new CheckListValueModel();
            }
          });
        }

        this.getApplicationNumber(this.applicationID, this.application);
        this.showFeeAttachmentTab();
        this.showInspectionInfoReqTab();
        this.showPendingPaymentTab();
        this.syncEthSwitchAttemptMarker();
        this.reconcileEthSwitchPaymentReturn();
        this.maybeAutoReconcileEthSwitchAfterLoad();
        this.getInspectionResultDoc();
        if (this.inspectionResults && this.inspectionResults.length) {
          if (this.accountService.isNotApplicant() || [Constants.CERTIFICATE_GENERATED,
          Constants.RETURN_TO_APPLICANT_CODE, Constants.REJECTED_CODE].indexOf(this.application.applicationStatusCode) > -1) {
            this.showInspectionResultTab = true;
            this.inspectionResults.forEach(element => {
              if(element.fileId){
                this.showFileColumnsInspectionResult = true;
              }
              if(element.odkResponseUUID){
                this.showOdkColumnsInspectionResult = true;
              }
            });
          }
        }
        if (this.application.applicationStatusCode === Constants.LEGACY_DATA_EDITED_CODE && this.currentUserRoleCodes[0] === Constants.DATA_ENTRY_CLERK) {
          this.showEditActionButtons = true;
        }
        if (this.application.applicationStatusCode === Constants.CERTIFICATE_GENERATED || this.application.applicationStatusCode === Constants.ARCHIVED) {

          if(this.application.applicationStatusCode === Constants.CERTIFICATE_GENERATED){
             this.showLicenseGeneratedAction = this.accountService.isUserDirector() && !this.application.isLegacyData;
          }
          if (this.currentUserRoleCodes[0] === Constants.DATA_ENTRY_CLERK) {
            this.showPreviewCertificate = false;
            this.showPreviewNotification = false;
            this.showEditActionButtons = true;
          } else if(this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
            this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE){
            this.showPreviewCertificate = this.containsCertificate;
            this.showPreviewNotification = this.containsPreview;
            this.showReturnToCSOAction = false;
          } else if(this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE ||
            this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE){
            this.showPreviewNotification = true;
            this.showReturnToCSOAction = false;
          } else{
            this.showPreviewCertificate = true;
            this.showReturnToCSOAction = false;
          }
        } else if(this.application.applicationStatusCode === Constants.CLOSED){
          this.showPreviewNotification = true;
        } else if (this.application.applicationStatusCode === Constants.FIR_REQUESTED &&
          ((this.accountService.isUserInspectionTeamLeader() && !this.application.isLegacyData) ||
            (this.application.isLegacyData && this.accountService.isUserCSO()))) {
          this.showPrescreeningActions = false;
          this.showRequestFIRAction = false;
          this.showChecklistScreeningActions = false;
          this.showSubmitForFIRAction = true;
          if (this.accountService.isUserInspectionTeamLeader() && !this.application.isLegacyData) {
            this.showReturnToInspectorActions = true;
            if(this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL &&
              this.application.isPreviousApplicationLegacyData){
              this.showReturnToCSOAction = true;
            }
          }
        } else if (this.application.applicationStatusCode === Constants.PRESCREENED_CODE) {
          
          if (this.accountService.isUserDirector() && (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
            this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE) &&
            this.application.flowType.flowTypeCode === Constants.APPLICATION_FLOW_TYPE_CODE_MINOR) {
            this.showApproveActions = true;
            this.showReturnToCSOAction = true;
          }

          if (this.accountService.isUserInspectionTeamLeader() &&
            this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL &&
            this.application.facility.facilityCategory &&
            this.application.facility.facilityCategory.name === Constants.FACILITY_CAT_GREEN) {
            this.showSubmitForApproval = true;
            this.showReturnToCSOAction = true;
          }

          if (this.accountService.isUserInspectionTeamLeader() &&
            (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
              this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE) &&
            this.application.flowType.flowTypeCode === Constants.APPLICATION_FLOW_TYPE_CODE_MINOR) {
            this.showSubmitForApproval = true;
            this.showReturnToCSOAction = true;
          }

        }  else if(this.application.applicationStatusCode === Constants.FI_SUBMITTED && this.application.applicationUserAssignemnts.length === 0
          && this.accountService.isUserInspectionTeamLeader()){
            this.showSubmitForApproval = true;
            this.showSubmitForFIRAction = true;
            if(this.application.isPreviousApplicationLegacyData){
              this.showSubmitLegacyDataForFIRAction = true;
            }
        } else if (this.application.applicationStatusCode === Constants.SUBMIT_FOR_APPROVAL_CODE &&
          this.accountService.isUserDirector()) {
          this.showApproveActions = true;
          if(this.application.applicationCategory.applicationCategoryCode == Constants.APPLICATION_TYPE_CODE_REPLACEMENT){
            this.showReturnToCSOTeamLeaderAction = true;
          }else if([Constants.APPLICATION_TYPE_CODE_RETURN_COC, Constants.APPLICATION_TYPE_CODE_TEMP_RETURN_COC ].indexOf(
            this.application.applicationCategory.applicationCategoryCode) !== -1){
            this.showCloseActions = true;
          }
        } else if (this.application.applicationStatusCode === Constants.SUBMIT_FOR_REJECTION_CODE &&
          this.accountService.isUserDirector()) {
          this.showRejectActions = true;
        } else if ([Constants.PRESCREENING_FAILED_CODE, Constants.WITHDRAWN_CODE,Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].indexOf(this.application.applicationStatusCode) > -1 &&
          this.accountService.isUserApplicant() && (this.currentUser.id === this.application.createdBy)) {
          this.showEditActionButtons = true;
        } else if (this.application.applicationStatusCode === Constants.CSO_ASSIGNED_CODE && this.isUserAssignedToApplication() &&
          this.accountService.isUserCSO()) {
          this.showPrescreeningActions = true;
          if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_NEW ||
            this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE ||
            (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE &&
              this.application.flowType.flowTypeCode === Constants.APPLICATION_FLOW_TYPE_CODE_MAJOR)) {
            this.showChecklistScreeningActions = true;
          }
          if ((this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL ||
            this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
            this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE) &&
            this.application.isPreviousApplicationLegacyData) {
            this.showRequestFIRAction = true;
          }
        } else if (this.application.applicationStatusCode === Constants.PAYMENT_MADE_CODE && this.isUserAssignedToApplication() &&
          this.accountService.isUserCSO()) {
          this.showPaymentMadeActions = true;
        } else if (this.application.applicationStatusCode === Constants.APPROVED_CODE && this.isUserAssignedToApplication() &&
          this.accountService.isUserCSO()) {
          this.showGenerateCertificate = true;
        } else if (this.application.applicationStatusCode === Constants.RETURN_TO_CSO_CODE && this.isUserAssignedToApplication() &&
          this.accountService.isUserCSO()) {
          this.showPrescreeningActions = true;
          if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL &&
            this.application.isPreviousApplicationLegacyData) {
            this.showRequestFIRAction = true;
          }
        } else if (this.application.applicationStatusCode === Constants.APPROVED_CODE && this.accountService.isUserCSOTeamLeader()) {
          this.showGenerateCertificate = true;
        } else if(this.application.applicationCategory.applicationCategoryCode == Constants.APPLICATION_TYPE_CODE_REPLACEMENT &&
          [Constants.REQUESTED_CODE, Constants.RETURN_TO_CSO_TEAM_LEADER_CODE].indexOf(this.application.applicationStatusCode) > -1 &&
          this.accountService.isUserCSOTeamLeader()){
            this.showPrescreeningActions = true;
            this.showSubmitForApproval = true;
        } else if ([Constants.APPLICATION_TYPE_CODE_RETURN_COC, Constants.APPLICATION_TYPE_CODE_TEMP_RETURN_COC ].indexOf(
          this.application.applicationCategory.applicationCategoryCode) !== -1 &&
          [Constants.REQUESTED_CODE, Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE].indexOf(this.application.applicationStatusCode) > -1 &&
          this.accountService.isUserInspectionTeamLeader()) {
            this.showPrescreeningActions = true;
            this.showSubmitForApproval = true;
        } else if (this.application.applicationStatusCode === Constants.VOID && this.accountService.isUserInspectionTeamLeader()) {
          this.showSubmitForFIRAction = true;
          if(this.application.isPreviousApplicationLegacyData){
            this.showSubmitLegacyDataForFIRAction = true;
          }
        } else if(this.application.applicationStatusCode == Constants.LICENSE_SUSPENDED || this.application.applicationStatusCode == Constants.LICENSE_CANCELLED){
          this.showUndoLicenseSuspensionActionButton = this.accountService.isUserDirector() && this.application.applicationStatusCode == Constants.LICENSE_SUSPENDED;
          this.showSuspensionLetter = this.application.applicationStatusCode == Constants.LICENSE_SUSPENDED && 
            this.application.documents.findIndex(d => d.referenceID === Constants.LICENSE_SUSPENSION_LETTER_REFERENCE_ID) != -1;
          this.showCancellationLetter = this.application.applicationStatusCode == Constants.LICENSE_CANCELLED && 
            this.application.documents.findIndex(d => d.referenceID === Constants.LICENSE_CANCELLATION_LETTER_REFERENCE_ID) != -1;
        }

        if ([Constants.CERTIFICATE_GENERATED, Constants.ARCHIVED, Constants.DELETED, Constants.CLOSED, Constants.VOID, Constants.LICENSE_SUSPENDED,
          Constants.LICENSE_CANCELLED].indexOf(this.application.applicationStatusCode) === -1
          && (this.accountService.isUserDirector() || this.accountService.isUserInspectionTeamLeader())) {
            this.showDeleteActionButton = true;
        } else if ((this.accountService.isUserDirector() || this.accountService.isUserInspectionTeamLeader()) &&
          this.application.applicationStatusCode === Constants.DELETED) {
          this.showUndoDeleteActionButton = !this.application.facility.isLicenseCancelled && !this.application.facility.isLicenseSuspended;
        }

        this.attachedDocs = this.application.documents;
        // filtering out the payment documents
        for (let i = 0; i < this.application.documents.length; i++) {

          if (this.application.documents[i].referenceID === Constants.PAYMENT_REFERENCE_ID) {

            if (this.application.documents[i].remark === Constants.NOT_VERIFIED) {

              this.currentReciptNumber = this.getReciptNumberByDocID(this.application.documents[i].id);

              this.currentPaymentDoc = this.application.documents[i];

            }

            this.feeDocuments.push(this.application.documents[i]);

          }

        }

        // sorting the documents by uploaded time
        this.feeDocuments = this.feeDocuments.sort((obj1, obj2) => {
          if (obj1.uploadTime < obj2.uploadTime) {
            return 1;
          }

          if (obj1.uploadTime > obj2.uploadTime) {
            return -1;
          }

          return 0;
        });

        // GET DOCUMENT REF LIST
        let instantiatedData = new ApplicationDetail(data, null);
        const facility = instantiatedData.facility;
        const prodTypeID = instantiatedData.productTypeID;
        var foodManDoc: FoodManufDoc = null;

        if (facility && facility.facilityType === Constants.MANUFACTURER && instantiatedData.productType === Constants.PRODUCT_TYPE_FOOD) {

          foodManDoc = { mLevelID: instantiatedData.mLevelID, mRLevelID: instantiatedData.mrLevelID };

        }
        if (facility && instantiatedData.productType) {
          const facilityTypeID = facility.facilityTypeID;
          const plc = (facility.ownershipTypeCode === Constants.PLC);
          const focalPerson = (instantiatedData.applicationTypeCode === Constants.FOCAL_PERSON);
          const category = instantiatedData.applicationCategory;
          const categoryCode = category && category.applicationCategoryCode;
          this.applicationService.getDocumentRef(facilityTypeID, prodTypeID, plc, focalPerson, category,
            categoryCode === 'REN' ? facility.facilityCategoryID : null, foodManDoc,
            (categoryCode === 'CHG' || categoryCode === 'CTC') ? this._changeTypes.map(c => c.changeTypeRefID) : null,
            categoryCode === 'REP' && instantiatedData.applicationInfo ? instantiatedData.applicationInfo.replacementReasonID : null)
            .subscribe(documents => {
              const seenDocRefIds = new Set<number>();
              const uniqueDocRefs: DocumentRef[] = [];
              let paymentDocRef: DocumentRef = null;
              for (const doc of documents || []) {
                if (!doc || doc.id === Constants.PAYMENT_REFERENCE_ID || doc.name === Constants.PAYMENT_DOC_NAME) {
                  if (doc && !paymentDocRef && doc.id === Constants.PAYMENT_REFERENCE_ID) {
                    paymentDocRef = doc;
                  }
                  continue;
                }
                if (seenDocRefIds.has(doc.id)) {
                  continue;
                }
                seenDocRefIds.add(doc.id);
                uniqueDocRefs.push(doc);
              }
              this.feeDocumentRefs = paymentDocRef
                ? [this.createPaymentDocRef(-1, this.feeDocuments.length, paymentDocRef)]
                : [];
              this.documentRefs = uniqueDocRefs;
              this.mergeUploadedDocumentRefs();
              var index = (this.application.documents || []).findIndex(d => d.referenceID == 39);//reference id for bank statement or investment license
              if (instantiatedData.productType == Constants.PRODUCT_TYPE_FOOD && instantiatedData.facility.facilityType == Constants.MANUFACTURER && instantiatedData.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_NEW && index === -1) {
                // fetch doc ref for Investment License and Bank Statement to show the documents of applications before they are merged together
                this.applicationService.getDocRefById(22).subscribe(doc => this.documentRefs.push(doc));
                this.applicationService.getDocRefById(23).subscribe(doc => this.documentRefs.push(doc));
              }
            },
              err => {
                this.errorMessage = err.message;
                this.mergeUploadedDocumentRefs();
              });
        } else {
          this.mergeUploadedDocumentRefs();
        }
        this.showLicenseNumber = [Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES, Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
        Constants.PRODUCT_TYPE_SMALL_SCALE_MEDICINE,Constants.PRODUCT_TYPE_MEDICAL_GAS].indexOf(this.application.productType) > -1;

        if(this.accountService.isUserSuperAdmin()){

          let isToBeInspected = [Constants.INSPECTOR_ASSIGNED_CODE, Constants.FI_SUBMITTED, Constants.RETURN_TO_INSPECTOR_CODE, Constants.INFO_FOR_INSPECTION_SUBMITTED].indexOf(
            this.application.applicationStatusCode) != -1;

          this.showDeleteQRCodeButton = isToBeInspected && this.isInspectionQRCodeDocAlreadyCreated();
        }

        if (preservePayingRef && !this.ethSwitchReconcileBillRef) {
          this.ethSwitchPayingBillRef = preservePayingRef;
        }
        this.applyEthSwitchReturnIncompletePending();
        this.syncBootstrapTabState();
        this.spinner.hide();
      },
      err => {
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      });
  }

  private compare(oldObj, newObj,dataType){
    var key: string;
    if (dataType == Constants.DATA_TYPE_FACILITY_NAME_CHANGE) {
      if (oldObj !== newObj) {
        this.diff['name'] = newObj
      }
    }
    else if (dataType == Constants.DATA_TYPE_PROFESSIONAL_CHANGE) {
      if (!oldObj || !newObj) {
        return this.diff;
      }
      const newTypeCode = newObj.professionalType && newObj.professionalType.professionalTypeCode;
      const typeCode = newTypeCode || (oldObj.professionalType && oldObj.professionalType.professionalTypeCode);
      if (!typeCode) {
        return this.diff;
      }
      const code = typeCode.toLowerCase();
      // A normal change stores professionalType on the new value, so keep walking the old object.
      // A value that only has professionalTypeID must not walk entity fields such as id or isActive.
      const source = newTypeCode ? oldObj : newObj;
      for (key in source) {
        if (oldObj[key] !== newObj[key]) {
          if(key === 'qualification'){
            continue;
          }
          else if(key === 'qualificationID'){
            this.diff[code + ('qualification'.charAt(0).toUpperCase() + 'qualification'.slice(1))] = newObj['qualification'];
          } else if(key === 'phone'){
            this.diff[code + 'PhoneNumber'] = newObj['phone'];// for highlighting in view
            this.diff[code + 'Phone'] = newObj['phone'];// for FIR
          }
          else{
            this.diff[code + (key.charAt(0).toUpperCase() + key.slice(1))] = newObj[key];
          }
        }
      }
    }
    else if (dataType == Constants.DATA_TYPE_PREMISE_MODIFICATION) {
      if (oldObj !== newObj) {
        this.diff['houseNo'] = newObj
      }
    }
    else if (dataType == Constants.DATA_TYPE_OWNERSHIP_CHANGE) {

      for (key in oldObj) {
        if (oldObj[key] !== newObj[key]) {
          if (key === 'ownerPhone') {
            this.diff['ownerPhoneNumber'] = newObj[key];
          }
          else if (key === 'organizationTypeID') {
            this.diff['ownershipType'] = newObj['organizationType'];
          }
          else {
            this.diff[key] = newObj[key];
          }
        }
      }

    }
    else if(dataType == Constants.DATA_TYPE_ADDITIONAL_PRODUCT){

      for (key in oldObj) {
        if (oldObj[key] !== newObj[key]) {
          if (key === 'facilitySpecificProducts') {
            this.diff['specificProducts'] = newObj[key];
          }
          else if (key === 'facilitySpecificProductItems') {
            this.diff['specificProductItems'] = newObj[key];
          }
          else {
            this.diff[key] = newObj[key];
          }
        }
      }

    }
    else if (dataType == Constants.DATA_TYPE_PRODUCT_TYPE_CHANGE) {
      for (key in oldObj) {
        if (oldObj[key] !== newObj[key]) {
            if(key == 'productType'){
              this.diff['productTypeID'] = newObj[key]['id'];
            } else if(key === 'facilitySpecificProducts'){
              this.diff['specificProducts'] = newObj[key];
            } else if (key === 'facilitySpecificProductItems') {
              this.diff['specificProductItems'] = newObj[key];
            } else {
              this.diff[key] = newObj[key];
            }
        }
      }
    }
    else {
      for(key in oldObj){
        if(oldObj[key] !== newObj[key]){
          this.diff[key] = newObj[key];
        }
      }
    }

    return this.diff;

  }

  completeClicked(complete) {
    const screenerResponse = {
      applicationId: this.application.id,
      checklistComplete: complete,
      checklistInstances: this.application.checkListItems
    };
    this.applicationService.checklistScreenedWithResponse(screenerResponse).subscribe(
      res => {
        if (res) {
          this.application.checklistComplete = complete;
          this.alertService.success('Successfully marked checklists as ' + (complete ? 'complete' : 'incomplete'));
        } else {
          this.alertService.error('Marking checklists as ' + (complete ? 'complete' : 'incomplete') + ' failed. Please try again later.');
        }
      },
      err => {
        this.alertService.error('Marking checklists as ' + (complete ? 'complete' : 'incomplete') + ' failed. Please try again later.');
      }
    );
  }

  disableButton() {
    for (let i = 0; i < this.application.checkListItems.length; i++) {
      if (!this.application.checkListItems[i].screenerResponseValue.name) {
        return true;
      }
    }
    return false;
  }

  compareButtonPressed() {
    this.compareMode = true;
    this.count = 0;
    this.application.checkListItems.forEach(checklist => {
      if(checklist.screenerResponseValue.name === checklist.checkListValue.name){
            this.count = this.count + 1
            this.checklistDiff = Math.round(((this.count/this.application.checkListItems.length)*100));

      }
      if (checklist.screenerResponseValue.name === 'N/A') {
        checklist.compareResult = true;
      } else {
        checklist.compareResult = checklist.screenerResponseValue.name === checklist.checkListValue.name;
      }
    });

  }

  ngOnInit() {
    this.uploader = new FileUploader({
      url: URL,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSize,
      headers: [{ name: 'Authorization', value: 'Bearer ' + this.accountService.getTokenData() }]
    });
    this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);
  }

  /** User returned from EthSwitch checkout tab — reconcile payment state. */
  @HostListener('document:visibilitychange')
  onDocumentVisibilityChange(): void {
    if (document.visibilityState === 'hidden') {
      if (this.ethSwitchPayingBillRef) {
        this.ethSwitchCheckoutWindowHidden = true;
      }
      return;
    }
    if (!this.ethSwitchPayingBillRef || !this.ethSwitchCheckoutWindowHidden) {
      return;
    }
    if (Date.now() - this.ethSwitchCheckoutOpenedAt < 2000) {
      return;
    }
    this.ethSwitchCheckoutWindowHidden = false;
    this.ethSwitchReconcileBillRef = this.ethSwitchPayingBillRef;
    this.ethSwitchPayingBillRef = null;
    this.getApplication();
  }

  private applyEthSwitchReturnIncompletePending(): void {
    if (!this.ethSwitchReturnIncompletePending) {
      return;
    }
    this.ethSwitchReturnIncompletePending = false;
    const active = this.sortedPaymentInfos[0];
    const ref = active ? this.getRowBillRef(active) : '';
    if (ref) {
      markEthSwitchAttemptIncomplete(this.applicationID, ref);
    }
  }

  /**
   * After checkout tab focus returns: ask FR to confirm if eris-payment already SUCCESS.
   * Falls back to incomplete marker when gateway still shows unpaid.
   */
  private reconcileEthSwitchPaymentReturn(): void {
    if (!this.ethSwitchReconcileBillRef) {
      return;
    }
    const ref = this.ethSwitchReconcileBillRef;
    this.ethSwitchReconcileBillRef = null;

    const row = this.sortedPaymentInfos.find(pi => this.getRowBillRef(pi) === ref);
    const receipt = (row?.recieptNumber ?? '').toString();
    if (row && receipt === 'PAYMENT_PENDING') {
      this.callEthSwitchReconcile(row, { markIncompleteOnFailure: true });
    } else {
      clearEthSwitchAttemptMarker(this.applicationID);
    }
  }

  /** Success redirect (no incomplete flag) or page reopen with a stuck pending ETHSwitch bill. */
  private maybeAutoReconcileEthSwitchAfterLoad(): void {
    const wasIncompleteReturn = this.ethSwitchReturnIncompletePending;
    const pending = this.sortedPaymentInfos.find(pi => this.isPayableEthSwitchRow(pi));
    if (!pending) {
      return;
    }
    const paymentInfoId = this.getRowId(pending);
    if (!paymentInfoId || this.ethSwitchAutoReconcileAttemptedIds.has(paymentInfoId)) {
      return;
    }
    // Skip auto-reconcile while an explicit post-checkout reconcile is already running.
    if (this.ethSwitchReconcileInFlight) {
      return;
    }
    this.ethSwitchAutoReconcileAttemptedIds.add(paymentInfoId);
    this.callEthSwitchReconcile(pending, {
      markIncompleteOnFailure: wasIncompleteReturn,
      silentIfUnpaid: true
    });
  }

  private callEthSwitchReconcile(
    paymentInfo: any,
    options: { markIncompleteOnFailure?: boolean; silentIfUnpaid?: boolean } = {}
  ): void {
    const paymentInfoId = this.getRowId(paymentInfo);
    const billRef = this.getRowBillRef(paymentInfo);
    if (!paymentInfoId || !this.applicationID || this.ethSwitchReconcileInFlight) {
      return;
    }

    this.ethSwitchReconcileInFlight = true;
    this.applicationService.reconcileEthSwitchPayment({
      applicationId: this.applicationID,
      paymentInfoId
    }).subscribe(
      () => {
        this.ethSwitchReconcileInFlight = false;
        clearEthSwitchAttemptMarker(this.applicationID);
        this.alertService.success('EthSwitch payment confirmed successfully.');
        this.getApplication();
      },
      err => {
        this.ethSwitchReconcileInFlight = false;
        const message = (err?.error?.message || err?.message || '').toString();
        const unpaid = /not completed|No EthSwitch payment attempt/i.test(message);
        if (unpaid) {
          if (options.markIncompleteOnFailure && billRef) {
            markEthSwitchAttemptIncomplete(this.applicationID, billRef);
          }
          if (!options.silentIfUnpaid) {
            this.alertService.warn(
              'EthSwitch payment is not completed yet. If you already paid, wait a moment and refresh this page.'
            );
          }
          return;
        }

        this.alertService.warn(
          (message
            ? message + ' '
            : 'Could not confirm EthSwitch payment automatically. ') +
          'Please refresh this page or contact support' +
          (billRef ? ` with bill reference ${billRef}` : '') + '.'
        );
      }
    );
  }

  /** Clear retry marker once payment is confirmed; keep it after failed/cancelled checkout. */
  private syncEthSwitchAttemptMarker(): void {
    const active = this.sortedPaymentInfos[0];
    if (!active || active.recieptNumber !== 'PAYMENT_PENDING') {
      clearEthSwitchAttemptMarker(this.applicationID);
    }
  }

  // docRefID will be the document id for payment doc
  previewModal(modalName: string, docRefID: number, byDocRefID = true) {
    var docId = 0;
    if(byDocRefID) {
      let doc = this.getDocument(docRefID);
      docId = doc.id
    } else {
      docId = docRefID;
    }
    
    console.log('currentAttachmentID', this.currentAttachmentID);
    const attachmentUrl = SubDataVariables.ATTACHMENT_SINGLE_URL + '/' + docId;
    this.previewService.openModal(attachmentUrl, modalName, true);
  }

  inspectionPreviewModal(inspectionResult: InspectionInfoDetail, filePreviewing: boolean){
    if(filePreviewing){
      // the old inspection result from uploaded doc
      let modalName = inspectionResult.fileName;
      let docID = inspectionResult.fileId;
      const attachmentUrl = SubDataVariables.ATTACHMENT_SINGLE_URL + '/' + docID;
      this.previewService.openModal(attachmentUrl, modalName, true);
    }else {
      // the new inspection result from odk virtual form
      this.currentInspectionResult = inspectionResult;
      this.showEnketoForm = true;
    }
  }

  // docRefID will be the document id for payment doc
  downloadAttachment(name: string, docRefID: number, byDocRefID = true) {
    var docId = 0;
    if(byDocRefID) {
      let doc = this.getDocument(docRefID);
      docId = doc.id;
    } else {
      docId = docRefID;
    }
    
    this.applicationService.getAttachmentByID(docId).subscribe(data => {
      const blob = new Blob([data], {
        type: 'application/pdf'
      });
      saveAs(blob, name);
    });
  }

  isTelebirrPaymentInProgress(billReferenceNumber: string): boolean {
    const ref = (billReferenceNumber ?? '').trim();
    return !!ref && this.telebirrPayingBillRef === ref;
  }

  isEthSwitchPaymentInProgress(billReferenceNumber: string): boolean {
    const ref = (billReferenceNumber ?? '').trim();
    return !!ref && this.ethSwitchPayingBillRef === ref;
  }

  // Robust resolvers — backend payload may come back camelCase OR PascalCase depending on
  // whether the row was just constructed in the frontend (PascalCase) or freshly fetched
  // from the API (camelCase). Use these everywhere the Pay-button block reads the row.
  getRowServiceProvider(pi: any): string {
    const provider = (pi?.payment?.serviceProvider || pi?.payment?.ServiceProvider || pi?.paymentMethod || '').toString();
    return provider || (pi?.recieptNumber === 'PAYMENT_PENDING' ? '' : 'CASH');
  }

  getRowBillRef(pi: any): string {
    return (pi?.payment?.billReferenceNumber || pi?.payment?.BillReferenceNumber || '').toString();
  }

  getRowAmount(pi: any): number {
    return Number(pi?.payment?.amount ?? pi?.payment?.Amount ?? 0);
  }

  getPaymentStatusName(pi: any): string {
    try {
      if (this.isEthSwitchPaymentCompleted(pi)) {
        return 'Completed';
      }
      const payment = pi?.payment ?? pi?.Payment;
      if (!payment) {
        return 'Completed';
      }
      const status = payment.status ?? payment.Status;
      const name = status?.name ?? status?.Name;
      if (typeof name === 'string' && name.trim()) {
        return name;
      }
      return 'Pending';
    } catch {
      return 'Pending';
    }
  }

  /** True when EthSwitch payment is settled (receipt set or payment status COMPL). */
  isEthSwitchPaymentCompleted(pi: any): boolean {
    if (!pi) {
      return false;
    }
    if (this.getRowServiceProvider(pi).toLowerCase() !== 'ethswitch') {
      return false;
    }
    const receipt = (pi?.recieptNumber ?? '').toString().trim();
    if (receipt && receipt !== 'PAYMENT_PENDING') {
      return true;
    }
    const payment = pi?.payment ?? pi?.Payment;
    const status = payment?.status ?? payment?.Status;
    const code = (
      status?.paymentStatusCode ??
      status?.PaymentStatusCode ??
      status?.code ??
      status?.Code ??
      ''
    ).toString().toUpperCase();
    const name = (status?.name ?? status?.Name ?? '').toString().toLowerCase();
    return code === 'COMPL' || name.includes('completed');
  }

  /** Receipt / transaction id shown in Actions when EthSwitch payment succeeded. */
  getEthSwitchReceiptNumber(pi: any): string {
    const receipt = (pi?.recieptNumber ?? '').toString().trim();
    if (receipt && receipt !== 'PAYMENT_PENDING') {
      return receipt;
    }
    const payment = pi?.payment ?? pi?.Payment;
    const transactionId = (payment?.transactionId ?? payment?.TransactionID ?? '').toString().trim();
    return transactionId || '—';
  }

  /** Receipt / transaction column — EthSwitch rows use payment status instead of raw PAYMENT_PENDING. */
  getRowReceiptOrTransactionId(pi: any): string {
    const receipt = (pi?.recieptNumber ?? '').toString().trim();
    const payment = pi?.payment ?? pi?.Payment;
    const transactionId = (payment?.transactionId ?? payment?.TransactionID ?? '').toString().trim();
    const isPendingReceipt = receipt === 'PAYMENT_PENDING';
    const provider = this.getRowServiceProvider(pi).toLowerCase();

    if (provider === 'ethswitch') {
      if (this.isEthSwitchPaymentCompleted(pi)) {
        return 'Payment completed';
      }
      if (!isPendingReceipt && receipt) {
        return receipt;
      }
      if (transactionId) {
        return transactionId;
      }
      if (isPendingReceipt) {
        const billRef = this.getRowBillRef(pi);
        if (billRef && this.isEthSwitchPaymentInProgress(billRef)) {
          return 'Payment in progress';
        }
        if (billRef && hasEthSwitchIncompleteAttempt(this.applicationID, billRef)) {
          return 'Payment not completed';
        }
        return 'Awaiting payment';
      }
      return receipt || '—';
    }

    if (isPendingReceipt) {
      return '—';
    }
    return receipt || transactionId || '—';
  }

  // True when this payment row is a pending Telebirr bill that the applicant should be able
  // to pay from this page. Case-insensitive on serviceProvider so a row stored as 'Telebirr'
  // (PascalCase variant) still renders the Pay button. Requires a bill reference because the
  // Telebirr CreateOrder call needs one.
  isPayableTelebirrRow(pi: any): boolean {
    if (!pi || pi.recieptNumber !== 'PAYMENT_PENDING') {
      return false;
    }
    return this.getRowServiceProvider(pi).toLowerCase() === 'telebirr'
      && !!this.getRowBillRef(pi);
  }

  isPayableEthSwitchRow(pi: any): boolean {
    if (!pi || this.isEthSwitchPaymentCompleted(pi)) {
      return false;
    }
    if (pi.recieptNumber !== 'PAYMENT_PENDING') {
      return false;
    }
    return this.getRowServiceProvider(pi).toLowerCase() === 'ethswitch'
      && !!this.getRowBillRef(pi);
  }

  // Returns paymentInfos sorted newest-first. We try id first; if missing/equal we fall back to
  // modifiedDate/createdDate, then to the original array order (backend appends, so the last
  // item is the newest bill). The first element is the active bill; everything after it is
  // historical and rendered as disabled in the template.
  get sortedPaymentInfos(): any[] {
    const items = this.application?.paymentInfos;
    if (!items || !items.length) {
      return [];
    }
    return [...items]
      .map((pi, idx) => ({ pi, idx }))
      .sort((a, b) => {
        const idA = this.getRowId(a.pi);
        const idB = this.getRowId(b.pi);
        if (idA !== idB) {
          return idB - idA;
        }
        const tA = this.getRowTimestamp(a.pi);
        const tB = this.getRowTimestamp(b.pi);
        if (tA !== tB) {
          return tB - tA;
        }
        // Stable fallback: backend appends new PaymentInfo records, so a higher original index
        // means a newer row. We want newest first, so subtract a.idx from b.idx.
        return b.idx - a.idx;
      })
      .map(x => x.pi);
  }

  // True only for the most recent paymentInfo. Used to gate the Pay button and the disabled
  // styling on the payments table so applicants can't try to pay an obsolete bill from history.
  isActivePaymentRow(pi: any): boolean {
    const sorted = this.sortedPaymentInfos;
    if (!sorted.length || !pi) { return false; }
    const head = sorted[0];
    const headId = this.getRowId(head);
    const piId = this.getRowId(pi);
    if (headId && piId) {
      return headId === piId;
    }
    // No id on either side — fall back to reference equality so the dimmed/active styling still
    // works even when the backend payload omits ids (or sends them PascalCased on a stale row).
    return head === pi;
  }

  private getRowId(pi: any): number {
    if (!pi) { return 0; }
    return Number(pi.id ?? pi.ID ?? pi.Id ?? 0) || 0;
  }

  private getRowTimestamp(pi: any): number {
    if (!pi) { return 0; }
    const raw = pi.modifiedDate ?? pi.ModifiedDate ?? pi.createdDate ?? pi.CreatedDate;
    if (!raw) { return 0; }
    const t = new Date(raw).getTime();
    return isNaN(t) ? 0 : t;
  }

  private showPaymentOnProgressMessage(): void {
    this.alertService.info(
      'Payment on progress. Complete payment in the Telebirr window, then refresh this page.'
    );
  }

  private showEthSwitchPaymentOnProgressMessage(): void {
    this.alertService.info(
      'Payment on progress. Complete payment in the EthSwitch window, then refresh this page.'
    );
  }

  initiatePayment(price: number, billReferenceNumber: string) {
    const ref = (billReferenceNumber ?? '').trim();
    if (!ref) {
      this.alertService.error('Bill reference is missing. Reload the page or contact support.');
      return;
    }
    if (this.isTelebirrPaymentInProgress(ref)) {
      this.showPaymentOnProgressMessage();
      return;
    }
    const request = new PaymentRequest();
    request.title = 'EFDA Payment';
    request.amount = price;
    request.billReferenceNumber = ref;
    // Per-click chooser wins; falls back to env build default; empty = let the backend decide.
    const resolvedMode = (this.selectedTelebirrMode || environment.telebirrCheckoutMode || '').trim();
    if (resolvedMode) {
      request.checkoutMode = resolvedMode;
    }

    this.telebirrPayingBillRef = ref;
    this.spinner.show();
    this.applicationService.createTelebirrOrder(request).subscribe(
      res => {
        this.spinner.hide();
        if (res?.rawRequest) {
          openPaymentCheckoutUrl(res.rawRequest.trim());
          this.showPaymentOnProgressMessage();
          this.viewHistoryLog(this.applicationID);
        } else {
          this.telebirrPayingBillRef = null;
          this.alertService.error('Could not start Telebirr payment. Please try again.');
        }
      },
      err => {
        this.spinner.hide();
        this.telebirrPayingBillRef = null;
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      }
    );
  }

  initiateEthSwitchPayment(paymentInfo: any) {
    const ref = this.getRowBillRef(paymentInfo).trim();
    const paymentInfoId = this.getRowId(paymentInfo);
    if (!ref) {
      this.alertService.error('Bill reference is missing. Reload the page or contact support.');
      return;
    }
    if (!paymentInfoId) {
      this.alertService.error('Payment info is missing. Reload the page or contact support.');
      return;
    }
    if (this.isEthSwitchPaymentInProgress(ref)) {
      this.showEthSwitchPaymentOnProgressMessage();
      return;
    }

    const amount = this.getRowAmount(paymentInfo);
    clearEthSwitchAttemptMarker(this.applicationID, ref);
    this.ethSwitchPayingBillRef = ref;
    this.ethSwitchCheckoutWindowHidden = false;
    this.changeDetectorRef.detectChanges();
    this.spinner.show();
    this.applicationService.createEthSwitchOrder({
      applicationId: this.applicationID,
      paymentInfoId,
      amount,
      currency: 'ETB'
    }).subscribe(
      res => {
        this.spinner.hide();
        const checkoutUrl = (res?.checkoutUrl ?? '').trim();
        if (checkoutUrl) {
          this.ethSwitchCheckoutOpenedAt = Date.now();
          openPaymentCheckoutUrl(checkoutUrl);
          this.showEthSwitchPaymentOnProgressMessage();
          this.changeDetectorRef.detectChanges();
          this.viewHistoryLog(this.applicationID);
        } else {
          this.ethSwitchPayingBillRef = null;
          this.alertService.error('Could not start EthSwitch payment. Please try again.');
        }
      },
      err => {
        this.spinner.hide();
        this.ethSwitchPayingBillRef = null;
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      }
    );
  }

  isFileAttached(docRefID) {
    const idx = this.attachedDocs.map(doc => {
      return doc.referenceID;
    }).findIndex((elt) => {
      return elt === docRefID;
    });
    if (idx !== -1) {
      this.currentAttachmentID = this.attachedDocs[idx].id;
      return true;
    } else {
      return false;
    }

  }

  getDocument(docRefID) {
    const idx = this.attachedDocs.map(doc => {
      return doc.referenceID;

    }).findIndex((elt) => {

      return elt === docRefID;
    });

    if (idx !== -1) {
      return this.attachedDocs[idx];
    } else {
      return null;
    }

  }

  getUploadTime(docRefID) {
    let doc = this.getDocument(docRefID);
    if (doc) {
      return this.getDateString(doc.uploadTime);
    }

    return '-';
  }

  getReciptNumberByDocID(docID) {
    const paymenInfo = this.application.paymentInfos.find(function (x) {
      return x.documentID === docID;
    });

    if (paymenInfo) {

      return paymenInfo.recieptNumber;
    }

    return null;

  }

  private mergeUploadedDocumentRefs() {
    if (!this.application || !this.application.documents) {
      return;
    }
    if (!this.documentRefs) {
      this.documentRefs = [];
    }
    const seen = new Set(this.documentRefs.filter(d => d).map(d => d.id));
    for (const doc of this.application.documents) {
      if (!doc || doc.referenceID == null || doc.referenceID === Constants.PAYMENT_REFERENCE_ID || seen.has(doc.referenceID)) {
        continue;
      }
      const ref = Object.assign(new DocumentRef(), doc.documentReference || {});
      ref.id = ref.id || doc.referenceID;
      if (!ref.name) {
        ref.name = doc.filePath ? doc.filePath.replace(/^.*[\\\/]/, '') : 'Attachment';
      }
      this.documentRefs.push(ref);
      seen.add(doc.referenceID);
    }
  }

  getFileName(docRefID) {
    let doc = this.getDocument(docRefID);
    if (doc && doc.filePath) {
      let fileName = doc.filePath.replace(/^.*[\\\/]/, '');
      if (!fileName.length) {
        fileName = '-';
      }

      return fileName;
    }

    return '-';
  }

  getInspectionFilesName() {
    this.inspectionResults.map(result => {
      if(result.fileName){
        let fileName = result.fileName.replace(/^.*[\\\/]/, '');
        !fileName.length ? result.fileName = '-' : result.fileName = fileName;
      }else {
        result.fileName = '-';
      }

      result.inspectionIdentifier = result.inspectionIdentifier || '-';
      result.uploadedTime = result.uploadedTime ? this.getDateString(result.uploadedTime) : '-';
      result.odkFormUploadDate = result.odkFormUploadDate ? this.getDateString(result.odkFormUploadDate) : '-';
      return result;
    });
  }

  getInspectionResultDoc() {
    this.inspectionResults = this.application.inspectionInfos;
    this.getInspectionFilesName();
    // this.inspectionResultID = this.inspectionResults[]['id'];
  }

  uploadPayment(event) {
    if (event) {
      this.ngAfterViewInit();
      $('#document-tab').tab('show');
    }
  }

  /**Methods for the show history section */
  viewHistoryLog(id) {
    this.applicationService.getApplicationHistory(id).subscribe(res => {
      this.historyLog = Array.isArray(res) ? res : [];
    }, () => {
      this.historyLog = [];
    });
  }

  abs(x) {
    return Math.abs(x);
  }

  mapStatusValues(code) {
    let returnDescription: string;
    switch (code) {
      case Constants.REQUESTED_CODE:
        returnDescription = Constants.REQUESTED_MESSAGE;
        break;
      case Constants.PRESCREENED_CODE:
        returnDescription = Constants.PRESCREENED_MESSAGE;
        break;
      case Constants.PRESCREENING_FAILED_CODE:
        returnDescription = Constants.PRESCREENING_FAILED;
        break;
      case Constants.PAYMENT_MADE_CODE:
        returnDescription = Constants.PAYMENT_MADE_MESSAGE;
        break;
      case Constants.PAYMENT_VERIFIED_CODE:
        returnDescription = Constants.PAYMENT_VERIFIED_MESSAGE;
        break;
      case Constants.PAYMENT_VERIFICATION_FAILED_CODE:
        returnDescription = Constants.PAYMENT_VERIFICATION_FAILED_MESSAGE;
        break;
      case Constants.INSPECTED_CODE:
        returnDescription = Constants.INSPECTED_MESSAGE;
        break;
      case Constants.INSPECTION_FAILED_CODE:
        returnDescription = Constants.INSPECTION_FAILED_MESSAGE;
        break;
      case Constants.WITHDRAWN_CODE:
        returnDescription = Constants.WITHDRAWN_MESSAGE;
        break;
      case Constants.APPROVED_CODE:
        returnDescription = Constants.APPROVED_MESSAGE;
        break;
      case Constants.REJECTED_CODE:
        returnDescription = Constants.REJECTED_MESSAGE;
        break;
      default:
        break;
    }
    return returnDescription;
  }

  getApplicationNumber(id, application) {
    this.applicationId = '0'.repeat(Math.max(5, id.toString().length)  - id.toString().length) + id + application.applicationNumber;
  }

  isApplicantFocalPerson() {
    if (this.application) {
      return (this.application.applicationTypeCode === Constants.FOCAL_PERSON);
    }
  }

  showModal(applicationStatus) {
    if (applicationStatus === Constants.CERTIFICATE_GENERATED) { // preview
      const attachmentUrl = SubDataVariables.CERTIFICATE_URL + '/' + this.applicationID;
      if(this.accountService.isUserDirector()){
        this.previewService.openModalCertificate(attachmentUrl,'Licensing Certificate',this.applicationID,true,true);
      }
      else{
        this.previewService.openModalCertificate(attachmentUrl,'Licensing Certificate',this.applicationID,true,false);
      }
    } else if (applicationStatus === Constants.PREVIEW_NOTIFICATION_LETTER) { // preview
      const attachmentUrl = SubDataVariables.NOTIFICATION_URL + '/' + this.applicationID;
      if(this.accountService.isUserDirector()){
        this.previewService.openModalCertificate(attachmentUrl,'Licensing Notification Letter',this.applicationID,true,true);
      }
      else{
        this.previewService.openModalCertificate(attachmentUrl,'Licensing Notification Letter',this.applicationID,true,false);
      }
    } else if (applicationStatus === Constants.GENERATE_CERTIFICATE) {
      $('#generateCertificateModal').modal('show');
    } else if (applicationStatus === Constants.PAYMENT_REFERRAL) { // preview
      this.applicationService.previewPaymentReferral(this.application.id).subscribe(data => {
        const blob = new Blob([data], {
          type: 'application/pdf'
        });
        this.previewService.openModalFile(blob, 'Payment Referral Document', true);
      });
    } else if (applicationStatus === Constants.FIR_REQUESTED &&
      (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL ||
      this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
      this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE) &&
      this.accountService.isUserCSO() && [Constants.RETURN_TO_CSO_CODE, Constants.CSO_ASSIGNED_CODE].indexOf(this.application.applicationStatusCode) > -1) {
      this.submitForm(Constants.FIR_REQUESTED, '');
    } else {
      if (applicationStatus === Constants.PRESCREENED_CODE) {
        this.modalTitle = 'Pass Screening';
        this.modalButtonLabel = Constants.PASS;
      } else if (applicationStatus === Constants.PRESCREENING_FAILED_CODE) {
        this.modalTitle = 'Fail Screening';
        this.modalButtonLabel = Constants.FAIL;
      } else if (applicationStatus === Constants.PAYMENT_VERIFIED_CODE) {
        this.modalTitle = 'Pass Payment Verification';
        this.modalButtonLabel = Constants.PASS;
      } else if (applicationStatus === Constants.PAYMENT_VERIFICATION_FAILED_CODE) {
        this.modalTitle = 'Fail Payment Verification';
        this.modalButtonLabel = Constants.FAIL;
      } else if (applicationStatus === Constants.INSPECTED_CODE) {
        this.modalTitle = 'Pass Inspection';
        this.modalButtonLabel = Constants.PASS;
      } else if (applicationStatus === Constants.INSPECTION_FAILED_CODE) {
        this.modalTitle = 'Fail Inspection';
        this.modalButtonLabel = Constants.FAIL;
      } else if (applicationStatus === Constants.REJECTED_CODE) {
        this.modalTitle = 'Reject Application';
        this.modalButtonLabel = Constants.FAIL;
      } else if (applicationStatus === Constants.SUBMIT_FOR_APPROVAL_CODE) {
        this.modalTitle = 'Submit For Approval';
        this.modalButtonLabel = Constants.PASS;
      } else if (applicationStatus === Constants.RETURN_TO_INSPECTOR_CODE) {
        this.modalTitle = 'Return to Inspector';
        this.modalButtonLabel = Constants.RETURN;
      } else if (applicationStatus === Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE) {
        this.modalTitle = 'Return to Inspector Team Leader';
        this.modalButtonLabel = Constants.RETURN;
      } else if (applicationStatus === Constants.RETURN_TO_APPLICANT_CODE) {
        this.modalTitle = 'Return to Applicant';
        this.modalButtonLabel = Constants.RETURN;
      } else if (applicationStatus === Constants.SUBMIT_FOR_REJECTION_CODE) {
        this.modalTitle = 'Submit For Rejection';
        this.modalButtonLabel = Constants.FAIL;
      } else if (applicationStatus === Constants.INSPECTION_REJECTED_CODE) {
        this.modalTitle = 'Reject Inspection';
        this.modalButtonLabel = Constants.FAIL;
      } else if (applicationStatus === Constants.RETURN_TO_CSO_CODE) {
        this.modalTitle = 'Return to CSO';
        this.modalButtonLabel = Constants.RETURN;
      } else if (applicationStatus === Constants.SELF_INSPECTION_FAILED_CODE) {
        this.modalTitle = 'Fail Self Inspection';
        this.modalButtonLabel = Constants.FAIL;
      } else if (applicationStatus === Constants.SELF_INSPECTION_PASSED_CODE) {
        this.modalTitle = 'Pass Self Inspection';
        this.modalButtonLabel = Constants.PASS;
      } else if (applicationStatus === Constants.FIR_REQUESTED) {
        this.modalTitle = 'Request FIR';
        this.modalButtonLabel = Constants.REQUEST;
      } else if (applicationStatus === Constants.FIR_SUBMITTED) {
        this.modalTitle = 'Submit FIR';
        this.modalButtonLabel = Constants.SUBMIT;
      } else if (applicationStatus === Constants.RETURN_TO_CSO_TEAM_LEADER_CODE) {
        this.modalTitle = 'Return to CSO Team Leader';
        this.modalButtonLabel = Constants.RETURN;
      } else if (applicationStatus === Constants.CLOSED) {
        this.modalTitle = 'Approve and Close';
        this.modalButtonLabel = Constants.APPROVE_CLOSE;
      } else if (applicationStatus === Constants.VOID) {
        this.modalTitle = 'Void Certificate';
        this.modalButtonLabel = Constants.VOID_CERTIFICATE;
      }else if (applicationStatus === Constants.DELETED) {
        this.modalTitle = 'Delete Application';
        this.modalButtonLabel = Constants.DELETE_APPLICATION;
      }else if (applicationStatus === Constants.UNDO_DELETE) {
        this.modalTitle = 'Undo Delete';
        this.modalButtonLabel = Constants.UNDO_DELETE_LABEL;
      }else if (applicationStatus === Constants.LEGACY_FIR_SUBMITTED) {
        this.modalTitle = 'Submit FIR for Legacy Application';
        this.modalButtonLabel = Constants.SUBMIT;
      }else if (applicationStatus === Constants.LICENSE_CANCELLED) {
          this.modalTitle = 'Cancel License';
          this.modalButtonLabel = Constants.CANCEL;
      } else if (applicationStatus === Constants.LICENSE_SUSPENDED) {
        this.modalTitle = 'Suspend License';
        this.modalButtonLabel = Constants.SUSPEND;
      } else if(applicationStatus === Constants.UNDO_LICENSE_SUSPENSION){
        this.modalTitle = 'Undo License Suspension';
        this.modalButtonLabel = Constants.UNDO_LICENSE_SUSPENSION_LABEL;
      }

      this.modalApplicationStatus = applicationStatus;

      $('#applicationModal').modal('show');
    }
  }

  openAlertModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  generateCertificate() {
    const data = {
      'applicationID': this.applicationID
    };
    this.spinner.show();
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.applicationService.generateCertificate(data).subscribe(
      response => {
        this.spinner.hide();
        if (response) {
          this.onCertificateGenerated(true);
          this.alertService.success('Certificate generated successfully. Wait 30 seconds to print the certificate.');
          this.router.navigate(['applications/all']);
        } else {
          this.alertService.error('Certificate Generation Failed.');
        }
      }, err => {
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      });
  }

  closeModal() {
    this.modalRef.hide();
  }

  showWithdrawModal() {
    this.modalTitle = 'Withdraw Application';
    this.modalButtonLabel = Constants.WITHDRAW;
    this.modalApplicationStatus = Constants.WITHDRAWN_CODE;
    $('#applicationModal').modal('show');
  }

  withdrawButtonShouldShow() {
    // Allow withdraw from REQUESTED (already supported) and PENDING_PAYMENT so an applicant can
    // abandon an unpaid Telebirr/CBE bill instead of being stuck on PPEND. The backend guards
    // late gateway callbacks so a successful payment that lands after withdraw does not silently
    // un-withdraw the application.
    return this.application && (this.erisLoginService.getUserId() === this.application.createdBy) &&
      (this.application.applicationStatusCode === this.constants.REQUESTED_CODE
        || this.application.applicationStatusCode === this.constants.PENDING_PAYMENT);
  }

  submitForm(statusCode, comment) {
    this.spinner.show();
    const data = {
      'applicationID': this.application.id,
      'statusCode': statusCode,
      'comment': comment
    };
    console.log(data);
    // send api
    this.applicationService.changeApplicationStatus(data).subscribe(
      response => {
        if (response) {
          $('#applicationModal').modal('hide');
          this.alertService.success('Application Updated Successfully');
          this.router.navigate(['/applications/list/' + this.application.previousApplicationID]);
        } else {
          $('#applicationModal').modal('hide');
          this.alertService.error('Application Update Failed');
        }
      }, err => {
        this.spinner.hide();
        $('#applicationModal').modal('hide');
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      });
  }

  getInspectionStatus(statusId) {
    if (this.historyLog) {
      const inspStatus = this.historyLog.find(function (x) {
        return x.newValue === statusId;
      });


      if (inspStatus && inspStatus.newCode === Constants.INSPECTION_FAILED_CODE) {

        return 'Fail';

      } else if (inspStatus && inspStatus.newCode === Constants.INSPECTED_CODE) {

        return 'Pass';
      }

    }

    return '';

  }

  getDateString(InputDate) {
    let date = new Date(InputDate);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric'});
  }

  // listens for event generated by generate-certificate-modal component
  onCertificateGenerated(generated: boolean) {
    this.showGenerateCertificate = !generated;
    this.showApproveActions = !generated;
    this.showLicenseGeneratedAction = generated;
    if(this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
      this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE){
      this.showPreviewCertificate = generated && this.containsCertificate;
      this.showPreviewNotification = generated && this.containsPreview;
    }  else {
      this.showPreviewCertificate = generated && [Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE,
        Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE].indexOf(this.application.applicationCategory.applicationCategoryCode) == -1;

      this.showPreviewNotification = generated && [Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE,
      Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE].indexOf(this.application.applicationCategory.applicationCategoryCode) !== -1;

    }
    this.viewHistoryLog(this.applicationID);
  }

  isUserAssignedToApplication(): boolean {
    return this.application.applicationUserAssignemnts.find(obj => obj.userID === this.erisLoginService.getUserId() && obj.primary) !== undefined;
  }

  screenerResponseChanged(instance) {
    if (this.compareMode) {
      this.compareButtonPressed();
    }
  }

  getPreviousApplicationId() {
    if (this.application.previousApplicationID) {
      return '0'.repeat(Math.max(5, this.application.previousApplicationID.toString().length) - this.application.previousApplicationID.toString().length) +
        this.application.previousApplicationID + this.application.previousApplicationNumber;
    }
  }

  showReturnToInspectorTeamLeaderAction() {
    if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_REPLACEMENT ||
      ((this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
        this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE) &&
      this.application.flowType.flowTypeCode === Constants.APPLICATION_FLOW_TYPE_CODE_MINOR)) {
      return false;
    } else {
      return this.showApproveActions || this.showRejectActions;
    }
  }

  editApplication() {
    if (this.currentUserRoleCodes[0] === Constants.DATA_ENTRY_CLERK) {
      this.router.navigateByUrl('/update/' + this.application.id);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_NEW) {
      this.router.navigateByUrl('/edit/' + this.application.id);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL) {
      this.router.navigateByUrl('/renewal/edit/' + this.application.id + '/' + false);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE) {
      this.router.navigateByUrl('/change/edit/' + this.application.id + '/' + false);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_REPLACEMENT) {
      this.router.navigateByUrl('/replacement/edit/' + this.application.id + '/' + false);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RETURN_COC) {
      this.router.navigateByUrl('/returnCOC/edit/' + this.application.id + '/' + false);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE) {
      this.router.navigateByUrl('/warehouseAddition/edit/' + this.application.id + '/' + false);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_COC){
      this.router.navigateByUrl('/tempCOC/edit/true/' + this.application.id);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE){
      this.router.navigateByUrl('/warehouseAdditionTemp/edit/true/' + this.application.id + '/' + false);
    } else if (this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE){
      this.router.navigateByUrl('/changeTemp/edit/true/' + this.application.id + '/' + false);
    } else if (this.application.applicationCategory.applicationCategoryCode == Constants.APPLICATION_TYPE_CODE_TEMP_RETURN_COC){
      this.router.navigateByUrl('/returnTempCOC/edit/true/' + this.application.id + '/' + false);
    }
  }

  checkForOldAndNewValue(data) {
    if (data.oldApplicationChangeTypes && data.oldApplicationChangeTypes.length > 0) {
      data.oldApplicationChangeTypes.forEach(element => {
        this.setNewAndOldFieldValues(data, element, false);
      });

    } 
    
    if(data.applicationCategory && (data.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
      data.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE) &&
      data.newApplicationChangeTypes && data.newApplicationChangeTypes.length > 0){

      data.newApplicationChangeTypes.forEach(element => {
        this.setNewAndOldFieldValues(data, element, true);
      });
    }

    return data;
  }

  setNewAndOldFieldValues(data, change, newVal) {
    const changeTypeName = change && change.changeType && change.changeType.changeTypeRef && change.changeType.changeTypeRef.name;
    if (!changeTypeName || !data.facility) {
      return;
    }
    const valueObj = newVal ? change.newValueObj : change.oldValueObj;
    // set facility name and ownership change values for backward compatability
    switch (changeTypeName) {
      case Constants.CHANGE_TYPE_FACILITY_NAME:
        this.containsCertificate = true;
        data.facility.name = newVal ? change.newValueObj : change.oldValueObj;
        break;
      case Constants.CHANGE_TYPE_ADDRESS:
        this.containsCertificate = true;
        break;
      case Constants.CHANGE_TYPE_OWNERSHIP_CHANGE:
        this.containsCertificate = true;
        if (valueObj) {
          data.facility.ownerName = valueObj.ownerName;
          data.facility.ownerPhoneNumber = valueObj.ownerPhone;
          if (valueObj.organizationType) {
            data.facility.ownershipType = valueObj.organizationType.name;
          }
        }
        break;
      case Constants.CHANGE_TYPE_TIN:
        this.containsCertificate = true;
        if (valueObj) {
          data.facility.ownerName = valueObj.ownerName;
          data.facility.ownerPhoneNumber = valueObj.ownerPhone;
          if (valueObj.type) {
            data.facility.ownershipType = valueObj.type.name;
          }
          data.facility.name = valueObj.name;
          data.facility.tinNumber = valueObj.tinNumber;
        }
        break;
       case Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE:
        this.containsCertificate = true
        break;
      case Constants.CHANGE_TYPE_SPECIFIC_PRODUCT_CHANGE_OR_ADDITION:
        this.containsCertificate = true;
        break;
      case Constants.CHANGE_TYPE_PRODUCT_LINE_ADDITION:
        this.containsPreview = true;
        break;
      case Constants.CHANGE_TYPE_PREMISE_MODIFICATION:
        this.containsPreview = true;
        this.containsCertificate = true;
        break;
      case Constants.STORE_MANAGER_NAME:
      case Constants.QUALITY_ASSURANCE_NAME:
      case Constants.PRODUCTION_MANAGER_NAME:
      case Constants.TECHNICAL_LEADER_NAME:
      case Constants.Quality_CONTROL_NAME:
        this.containsCertificate = true;
        break;
      case Constants.HYGIENE_AND_SANITATION_EXPERT_NAME:
      case Constants.PHYSICO_CHEMICAL_EXPERT_Name:
      case Constants.MICROBIOLOGIST_Name:
        this.containsPreview = true;
        break;  
    }

    this.containsPreview = this.containsPreview && newVal;
    this.containsCertificate = this.containsCertificate && newVal;
  }

  fetchConfiguredProfessionalTypes() {
    this.configuredProfessionalTypes = [];
    if (!this.application || !this.application.applicationCategory || !this.application.facility) {
      this.detailReady = true;
      return;
    }
    let professionalConfigFilter = new ProfessionalConfigFilter();
    if([Constants.APPLICATION_TYPE_CODE_TEMP_COC, Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE, Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE,
      Constants.APPLICATION_TYPE_CODE_TEMP_RETURN_COC].indexOf(this.application.applicationCategory.applicationCategoryCode) > -1){
        professionalConfigFilter.applicationCategoryID = 7; // id for TCC
    } else if (this.application.applicationCategory.applicationCategoryCode == Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE){
        professionalConfigFilter.applicationCategoryID = this.application.applicationCategoryID;
    } else {
        professionalConfigFilter.applicationCategoryID = 1; // id for new application
    }

    professionalConfigFilter.facilityTypeID = this.application.facility.facilityTypeID;
    professionalConfigFilter.productTypeID =  this.application.productTypeID;

    if(this.showFoodManufacturing || (this.showManufacturing && this.application.productType === Constants.PRODUCT_TYPE_COSMETICS)){
      professionalConfigFilter.manufacturingRiskLevelID = this.application.mrLevelID;
      professionalConfigFilter.manufacturingLevelID = this.application.mLevelID;
    }

    this.settingsService.getConfiguredProfessionalTypes(professionalConfigFilter).subscribe( res => {
      this.configuredProfessionalTypes = res || [];
      this.detailReady = true;
    }, err => {
      this.alertService.error(this.errorHandlerService.handleApiError(err));
      this.detailReady = true;
    }, () => {

    });
  }

  isProfessionalTypeVisible(professionalTypeCode)
  {
    return this.configuredProfessionalTypes.findIndex(p => p.professionalTypeCode == professionalTypeCode) > -1;
  }

  onEnketoFormClosed(closed: boolean){
    if(closed){
      this.showEnketoForm = false;
    }
  }

  setExperienceRange(data){
    if( data.oldApplicationChangeTypes && data.oldApplicationChangeTypes.length > 0) {

      data.oldApplicationChangeTypes.filter(c => c.dataType == "Professional").forEach(change => {

        var index = data.professionals.findIndex(p => p.professionalTypeID === change.newValueObj.professionalTypeID);
        if (index !== -1 && change.oldValueObj) {
          data.professionals[index].experienceYearRange = change.oldValueObj.experienceYearRange;
        }  

      });

    }
  }

  isInspectionQRCodeDocAlreadyCreated(){
    let submittedInspectionOdkIds = this.application.inspectionInfos.map(i => i.inspectionIdentifier);
    let qrCodeDocs = this.application.documents.filter(d => d.referenceID == 64 && submittedInspectionOdkIds.indexOf(d.remark) === -1); // inspection QR code document
    return qrCodeDocs.length !== 0;
  }

  deleteQRCodeDocument(){
    this.spinner.show();
    this.applicationService.deleteQRCodeDocument(this.application.id).subscribe(resp => {
      this.spinner.hide();
      this.closeModal();
      if(resp){
        this.alertService.success("Inspection QR Code document Deleted successfully!");
        this.router.navigateByUrl('/applications/all');
      } else {
        this.alertService.success("Couldn't delete the Inspection QR Code document!");
      }
    }, err => {
      this.spinner.hide();
      this.closeModal();
      this.alertService.success("Couldn't delete the Inspection QR Code document!");
    })
  }

  gpsMarkerClicked(latitude: number, longitude: number){
    window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, '_blank');
  }

  showInspectionInfoReqTab(){
    let showTab = this.accountService.isUserApplicant() && this.application.applicationStatusCode === Constants.INFO_FOR_INSPECTION_REQUESTED;
    let usedPreReqDocIds = this.application.inspectionInfos.flatMap(i => i.inspectionInfoDocuments).map(d => d.documentID);
    let preReqDocs = this.application.documents.filter(d => (d.documentReference.name == Constants.CONSENT_FORM_DOC || 
        d.documentReference.name == Constants.ADDITIONAL_DOCS_FOR_INSPECTION) && !usedPreReqDocIds.includes(d.id));

    let isEditing = preReqDocs.length > 0;
    
    if(showTab){
      this.activeTab = 'inspectionInfoRequest';
      this.activateTab(this.activeTab);
      this.applicationService.getPreInspectionDocRefs().subscribe(documentRefsResp => {
        this.preInspectionDocRefs = documentRefsResp;
        this.alertService.warn("Dear Applicant, Please give access to your location or pin you facility location on the map");
        this.mapsAPILoader.load().then(() => {
          if(!isEditing){
            if ('geolocation' in navigator) {
              navigator.geolocation.getCurrentPosition((position) => {
                this.facilityLocLatitiude = position.coords.latitude;
                this.facilityLocLongitude = position.coords.longitude;
              }, (error) => {
                console.log(error);
                if(error.message == "User denied Geolocation"){
                  this.alertService.error("Dear Applicant, You have rejected request for Location access, please pin your facility location on the map");
                }
              });
            }
          } else {
            // if editing load the facility gps location and the documents
            let consentDoc = preReqDocs.filter(prd => prd.documentReference.name == Constants.CONSENT_FORM_DOC);
            if(consentDoc && consentDoc.length > 0){
              let loc = consentDoc[0].remark;
              if(loc && loc.split('_').length == 2){
                this.facilityLocLatitiude = Number(loc.split('_')[0]);
                this.facilityLocLongitude = Number(loc.split('_')[1]);
              }
            }

            this.editDocuments = preReqDocs;
          }
          this.showInspectionInfoRequestTab = true;// set it here to makesure the app-file-upload component is activated after editDocuments is set
        });
      });
    }
  }

  onMapClick(event){
    this.facilityLocLatitiude = event.coords.lat;
    this.facilityLocLongitude = event.coords.lng;
  }
        
  submitPreInspectionPrerequisiteInfo() {
    this.spinner.show();
    let data = {documents: this.documents, facilityLocationLatitude: this.facilityLocLatitiude, facilityLocationLongitude: this.facilityLocLongitude, 
      applicationID: this.applicationID};
    this.applicationService.submitPreInspectionPrerequisiteInfo(data).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        this.alertService.success("PreInspection Prerequisite Information Submitted  Successfully!");
        this.router.navigate(["applications/all"]);
      }else {
        this.alertService.error("PreInspection Prerequisite Information Couldn't be Submitted, Try again!");
      }
    }, err => {
      this.spinner.hide();
      console.log(err);
      this.alertService.error( err.error?.Message ?? "PreInspection Prerequisite Information Couldn't be Submitted, Try again!");
    })
  }

  checkPreInsectionDocsUploaded(){
    let reqDocumentsCount = 0;
    let reqDocRefCount = this.preInspectionDocRefs.filter(d => d.required == true).length;
    this.documents.forEach(element => {
      if (element.referenceID !== null) {
       let index =  this.preInspectionDocRefs.findIndex(dr => dr.id === element.referenceID);
       if (index !== -1) {
         return this.preInspectionDocRefs[index].required ? reqDocumentsCount++ : null;
       }
      }
    });

    return reqDocumentsCount >= reqDocRefCount;
  }

  isLocationValid(){
    // check that the location is in ethiopia
    return this.ETH_LAT_LOWER <= this.facilityLocLatitiude && this.facilityLocLatitiude <= this.ETH_LAT_HIGHER &&
      this.ETH_LNG_LOWER <= this.facilityLocLongitude && this.facilityLocLongitude <= this.ETH_LNG_HIGHER;
  }

  showInspDocModal(inspectionResultId: number, template: TemplateRef < any > ) {
    this.currentInspectionResult = this.inspectionResults.filter(r => r.id == inspectionResultId)[0];
    this.modalTitle = 'Inspection Prerequisite Documents';
    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  previewInspectionPrerequisiteFile(modalName, docId) {
    const attachmentUrl = SubDataVariables.ATTACHMENT_SINGLE_URL + '/' + docId;
    this.previewService.openModal(attachmentUrl, modalName, true);
  }

  showPendingPaymentTab() {
    let showTab = this.application.applicationStatusCode === Constants.PENDING_PAYMENT;

    if(showTab) {
      const paymentInfo = this.sortedPaymentInfos[0];
      if (!paymentInfo) {
        return;
      }
      if(paymentInfo.recieptNumber == "PAYMENT_PENDING") {
        this.pendingPaymentInformation = new PendingPaymentInfo();
        this.pendingPaymentInformation.amount = this.getRowAmount(paymentInfo);
        this.pendingPaymentInformation.billReferenceNumber = this.getRowBillRef(paymentInfo);
        this.pendingPaymentInformation.paymentMethod = this.getRowServiceProvider(paymentInfo);
        this.pendingPaymentInformation.customerName = paymentInfo.payment?.behalfOf || paymentInfo.payment?.BehalfOf;
        // this.activeTab = "pendingPaymentInfo";
        if (this.activeTab !== 'payments') {
          this.activeTab = 'payments';
          this.activateTab(this.activeTab);
        }
      }
    }
  }
  
  isUserSuperadmin() {
    return this.accountService.isUserSuperAdmin();
  }

  regenerateCertificate() {
    this.spinner.show();
    this.applicationService.regenerateCertificate(this.applicationID).subscribe(resp => {
      this.spinner.hide();
      this.alertService.success("Successfully Regenerated! check after thirty seconds");
    }, error => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(error));
    });
  }

  regenerateNotificationLetter() {
    this.spinner.show();
    this.applicationService.regenerateNotificationLetter(this.applicationID).subscribe(resp => {
      this.spinner.hide();
      this.alertService.success("Successfully Regenerated! check after thirty seconds");
    }, error => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(error));
    });
  }

  createPaymentDocRef(i: number, length: number, paymentDocRef: DocumentRef ) {
    let paymentDR = new DocumentRef();
    if (i === -1) {
      paymentDR.name = paymentDocRef.name ;
    } else {
      paymentDR.name = `${paymentDocRef.name} (${length - i})`;
      paymentDR.fileIndex = i;
    }
    paymentDR.description = paymentDocRef.description;
    paymentDR.id = Constants.PAYMENT_REFERENCE_ID;
    return paymentDR;
  }

  onPaymentMethodChange(event) {
    this.selectedPaymentMethod = event.target.value;
    if(this.selectedPaymentMethod == "CASH") {
      this.showCashPayment = true;
    } else {
      this.showCashPayment = false;
    }
  }

  generateBillNumber() {
    this.spinner.show();
    this.applicationService.generateBillNumber(this.applicationID).subscribe(resp=> {
      this.spinner.hide();
      if(resp.isSuccess) {
        this.alertService.success("Bill Number Generated Successfully");
        this.router.navigate(['applications/all']);
      } else {
        this.alertService.error(resp.message);
      }
    }, error => {
      this.spinner.hide();
      console.log(error);
      this.alertService.error("Generating Bill Number failed, please try again!");
    })
  }
}

